import type { apiClient } from '~/shared/api/data-ingestion-api'
import type { AuditTrailEventDescriptionField, PayorEventProps } from '../../model'
import { collectFieldSearchText } from './searchable-text-utils'

export function transformPayor(event: apiClient.AuditEvent, isEob?: boolean): PayorEventProps {
  let fields: AuditTrailEventDescriptionField[] | null = null
  if (event.payor_match?.payor) {
    fields = [
      {
        label: 'Payor',
        values: [
          {
            diff: [`${event.payor_match.payor.payorId} - ${event.payor_match.payor.payorName}`],
          },
        ],
      },
    ]
  }

  return {
    type: 'payor',
    timestamp: event.timestamp,
    user: event.user,
    userRole: event.user ? 'person' : 'opti',
    step: isEob ? 'eob-payment-deposit' : 'data',
    ...(isEob && { visibleInSteps: ['eob-payment-deposit', 'eob-processing'] as const }),
    eventType: event.event_type,
    title: isEob ? 'Payment Deposit: Suggested payor' : 'Data Extraction: Suggested payor',
    fields,
  }
}

export function getPayorSearchableText(props: PayorEventProps): string {
  const parts = [props.title]
  if (props.fields) parts.push(collectFieldSearchText(props.fields))
  return parts.join(' ')
}
